export const constants = Object.freeze({
  TITLE: 'AR App',
  VERSION: 'version'
})
